import { gql } from '@apollo/client';
const UPDATE_ORDER_MODEL_VARIANT = gql `
  mutation UpdateOrderModelVariant($variantsQuantity: [[ID]]!) {
    updateOrderModelVariant(variantsQuantity: $variantsQuantity) {
      orderModelNode {
        id
      }
    }
  }
`;
export default UPDATE_ORDER_MODEL_VARIANT;
